import type { TokenPair, User } from "../api/client";

const STORAGE_KEY = "dote-web.auth.v1";

export interface AuthState {
  accessToken: string;
  refreshToken: string;
  expiresAt: number;
  user: User;
}

export function loadAuthState(): AuthState | null {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw) as AuthState;
  } catch {
    localStorage.removeItem(STORAGE_KEY);
    return null;
  }
}

export function saveAuthState(state: AuthState): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
}

export function clearAuthState(): void {
  localStorage.removeItem(STORAGE_KEY);
}

export function authStateFromTokenPair(pair: TokenPair): AuthState {
  return {
    accessToken: pair.access_token,
    refreshToken: pair.refresh_token,
    expiresAt: Date.now() + pair.expires_in * 1000,
    user: pair.user,
  };
}

export function shouldRefreshSoon(auth: AuthState | null): boolean {
  if (!auth) {
    return false;
  }
  return auth.expiresAt - Date.now() < 60_000;
}
